import React from 'react';
import './style.css';
import { Footer, Header, HeaderPages } from "../../components";

export const ContactPage: React.FC = () => {

    const ContactPanel = () => {
        return (
            <div className="contact-panel light-background section">
                <div className="panel-contents">
                    <div className="panel-title">
                        Contact Us
                    </div>
                    <div className="contact-info">
                        Haku Technology<br/>
                        10531 4S Commons Dr., Suite 166, San Diego, CA 92130<br/>
                        contact@hakutechnology.com
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Header currentPage={HeaderPages.Contact} />
            <ContactPanel />
            <Footer />
        </>
    );
};